/**
 * 管理后台布局组件
 *
 * 提供带侧边栏的管理后台布局，包括：
 * - 左侧导航侧边栏
 * - 右侧主内容区域
 */

import React from 'react';
import { AdminSidebar } from './AdminSidebar';
import { useNavigate } from 'react-router-dom';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  return (
    <div className="flex h-screen bg-white">
      {/* 侧边栏 */}
      <div className="w-16 flex-shrink-0">
        <AdminSidebar onLogout={handleLogout} collapsed={true} />
      </div>

      {/* 主内容区 */}
      <div className="flex-1 overflow-auto" style={{ scrollbarGutter: 'stable' }}>
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
